<template>
    <ChartBlock :data="data" v-if="isLoading" />
    <LoadingWrap v-else />
</template>

<script>
import { getDartData } from '@/api';
import ChartBlock from '@/components/ChartBlock.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';

export default {
    components: {
        ChartBlock,
        LoadingWrap,
    },
    data() {
        return {
            isLoading: false,
            data: {
                unit: '천원',
                step: 100000000,
                type: [
                    {
                        name: '매출액',
                        type: 'bar',
                        color: ['#5f48c4', '#8873e6'],
                        data: [],
                    },
                    {
                        name: '매출총이익',
                        type: 'bar',
                        color: ['#fac438', '#f7d57d'],
                        data: [],
                    },
                    {
                        name: '영업이익(손실)',
                        type: 'bar',
                        color: ['#f96835', '#f99571'],
                        data: [],
                    },
                    {
                        name: '법인세비용차감전순이익(손실)',
                        type: 'bar',
                        color: ['#21c389', '#78d1b1'],
                        data: [],
                    },
                    {
                        name: '당기순이익(손실)',
                        type: 'bar',
                        color: ['#446bc2', '#7793d1'],
                        data: [],
                    },
                ],
                years: [],
            },
        };
    },
    async mounted() {
        const {
            data: { PL },
        } = await getDartData();
        const modifyData = Object.keys(PL).reduce(
            (acc, key) => {
                Object.entries(PL[key]).forEach((entrie) => {
                    if (!acc.years.includes(entrie[0])) acc.years.push(entrie[0]);
                    if (!acc.type[key]) {
                        acc.type[key] = [entrie[1]];
                    } else {
                        acc.type[key].push(entrie[1]);
                    }
                });
                return acc;
            },
            {
                type: {},
                years: [],
            }
        );

        this.data.type[0].data = modifyData.type.revenue; //매출액
        this.data.type[1].data = modifyData.type.grossProfitAssets; //매출총이익
        this.data.type[2].data = modifyData.type.operatingIncomeLossAssets; //영억이익(손실)
        this.data.type[3].data = modifyData.type.profitLossBeforeTax; //법인세비용차감전순이익(손실)
        this.data.type[4].data = modifyData.type.profitLoss; //당기순이익(손실)
        this.data.years = modifyData.years;

        this.isLoading = true;
    },
};
</script>

<style></style>
